if (!yy.ast) {
    yy.ast = _ast;
    _ast.initialize();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonpath/include/action.js
// module id = 3206
// module chunks = 1137